export default {
  message: {
    success: "成功",
    fail: "失败"
  },

  search:{
    total_order_count:'订单数总计',
    total_amount_spent:'已花费金额总计',
    created:'创建于',
    order:'订单',
    shipping_information:'送货信息',
    shipping_address:'送货地址',
    phone:'电话号码',
    tracking_numbers:'跟踪号码',
    view_order:'跳转订单信息页面',
    product_details:'商品详情',
    view_in_background:'在后台查看',
    payment_breakdown:'支付明细',
    subtotal:'小计',
    shipping:'送货',
    items:'个项目',
    total:'总计',
    payment_method:'付款方式',
    paid_by_customer:'客户已支付',
    not_found:'无',

    disputed_information:'纠纷信息', //纠纷信息
    case_ID:"事件编号",
    receiving_account:"收款账号",
    opened_on:"开立时间",
    reason:"争议理由",
    status:"事件状态",
    disputed_amount:"争议金额",

  },

  navbar: {
    language: '语言',
    logOut: '退出登陆', //退出登陆
    submit:'提交', //提交
    label_options:'标签选项', //标签选项
    close_other:'关闭其他', //关闭其他
    close_all:'关闭所有', //关闭所有
  },
  //登陆注册的不用管
  login: {
    title: '客户端登陆',
    logIn: '登陆',
    register: '注册',
  },
  register: {
    title: '注册',
    firstName: '名',
    lastName: '姓',
    password: '密码',
    checkPass: '确认密码',
    captcha: '验证码',
    submit: '提交',
    reset: '重置',
    cancel: '取消',
  },

  password:{
    changePassword:'修改密码', //修改密码
    enterOldPassword:'输入旧密码', //输入旧密码
    newPassword:'输入新密码', //输入新密码
    confirmNewPassword:'确认新密码', //确认新密码
  },
  http:{
    unauthorized:'未授权，请重新登录',//未授权，请重新登录
  },
  disputed_status:{
    'Waiting for seller response':'等待卖家回复',
    'Under review':'审查中',
    'Waiting for buyer response':'等待买家回复',
    'Resolved':'已完成',
  },
  disputed_reason:{
    'MERCHANDISE_OR_SERVICE_NOT_RECEIVED':'物品未收到',
    'MERCHANDISE_OR_SERVICE_NOT_AS_DESCRIBED':'物品与描述不符',
    'UNAUTHORISED':'未经授权的交易',
    'CREDIT_NOT_PROCESSED':'未为客户处理信用交易',
    'DUPLICATE_TRANSACTION':'该交易是重复的',
    'INCORRECT_AMOUNT':'客户被收取了错误的金额',
    'PAYMENT_BY_OTHER_MEANS':'客户通过其他方式支付交易费用',
    'CANCELED_RECURRING_BILLING':'客户因取消定期计费而被错误收费',
    'OTHER':'其他',
  },
  disputed_base:{
    'BUYER':'买家',
    'SELLER':'卖家'
  }

}
